import * as React from "react";
const SvgIconBreadcrumbArrow = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6 11.06L9.05333 8L6 4.94L6.94 4L10.94 8L6.94 12L6 11.06Z", fill: "#A1A1AA" }));
export default SvgIconBreadcrumbArrow;
